import { FC, useEffect, useState } from "react";

import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
  listRmsExportError,
  RmsExportErrorListItem,
} from "@rubi/api-generated";
import { Link, useNavigate } from "react-router-dom";

import { Breadcrumbs, Crumb, DevPage, ErrorMsg, Section } from "./common";

const columns: GridColDef[] = [
  {
    field: "time_created",
    headerName: "Time",
    width: 200,
    valueFormatter: (value: string) => new Date(value).toLocaleString(),
  },
  { field: "org_title", headerName: "Org Name", width: 200 },
  { field: "tracking_number", headerName: "Tracking Number", width: 160 },
  { field: "survey_name", headerName: "Survey Name", width: 180 },
  {
    field: "error_message",
    headerName: "Error",
    flex: 1,
    minWidth: 300,
  },
];

export const DevRmsExportErrorsPage: FC = () => {
  const [errors, setErrors] = useState<RmsExportErrorListItem[]>([]);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const loadErrors = async () => {
    setLoading(true);
    setErrorMsg(null);
    const response = await listRmsExportError({ throwOnError: false });
    if (response.status === 200) {
      setErrors(response.data!.errors);
    } else {
      setErrors([]);
      setErrorMsg("" + response.status + " " + response.error?.console_msg);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadErrors();
  }, []);

  return (
    <DevPage
      title="RMS Export Errors"
      breadcrumbs={
        <Breadcrumbs>
          <Crumb>
            <Link to="/">Home</Link>
          </Crumb>
          <Crumb>
            <Link to="/dev_admin">Dev Admin</Link>
          </Crumb>
          <Crumb>RMS Export Errors</Crumb>
        </Breadcrumbs>
      }
    >
      <Section>
        <ErrorMsg msg={errorMsg} />
        <button onClick={loadErrors} style={{ marginBottom: 16 }}>
          Reload
        </button>
        <div style={{ width: "100%" }}>
          <DataGrid
            rows={errors}
            columns={columns}
            loading={loading}
            autoHeight
            initialState={{
              pagination: { paginationModel: { pageSize: 25 } },
            }}
            pageSizeOptions={[10, 25, 50]}
            onRowClick={(params) =>
              navigate(`/dev_admin/rms_export_error/${params.id}`)
            }
            sx={{ cursor: "pointer" }}
          />
        </div>
      </Section>
    </DevPage>
  );
};
